/** @jsx h */
import { Fragment } from 'preact';

const Loading = () => (
  <Fragment>
    <div className="loading-blur" />
    <div className="loading-spinner">
      <svg
        className="loading-spinner__svg"
        viewBox="25 25 50 50"
        aria-hidden="true"
        role="img"
        focusable="false"
      >
        <circle
          className="loading-spinner__circle"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  </Fragment>
);

export default Loading;
